export enum LegListFilterTabsEnum {
  filter = 0,
  sorting = 1,
}
